<select id=action required value={action} class="text lockable" {onchange}>
	<option value="" disabled selected hidden>Aktion</option>
	{#each Object.keys(groupedOptions) as optGroup}
    <optgroup label={protoDomains[optGroup]?.name ?? optGroup}>
      {#each groupedOptions[optGroup] as action}
        <option value={action.name}>{action.name}</option>
      {/each}
    </optgroup>
	{/each}
</select>


<script>
  import {protoActions, protoDomains} from "../core.js";


  let { currency, action = "", onchange } = $props();

	let groupedOptions = $derived(
		Object.groupBy(
			view.persona.options
				.map(optID => protoActions[optID])
				.filter(action => (currency === 'side') ? action?.execution === 'reactive' : ['active', 'proactive', 'ultimative', 'progressive', 'passive'].includes(action?.execution))
		, ({domain}) => domain)
	)
</script>

<style lang="sass">
	@use "../colors" as colors

	select:invalid
		color: grey

	select option
		color: colors.$white
</style>